<template>
  <div class="app-header">
    <div class="brand-header w-full text-brand pt-4 pb-8 container m-auto">
      <div class="lg:w-1/2 m-auto flex justify-between items-center px-2 flex-wrap">
        <div class="flex items-center mr-4">
        <h2 class="font-bold font-mono flex items-center justify-between">
          <router-link class="logo no-underline text-white font-mono" to="/"><img src="/tap-favicon-96px.png" width="25" alt="Tap" /></router-link>
        </h2>

        <div v-if="showNav" class="text-sm flex justify-en">
          <router-link
            class="ml-4 no-wrap underline tracking-wide font-bold text-black"
            to="/account">Account</router-link>

          <router-link class="ml-4 no-wrap text-black font-bold underline tracking-wide" to="/build">
            Build
          </router-link>
        </div>
        </div>
        <form @submit.prevent="doSearch">
          <div class="flex items-center my-2">

            <input
              v-model="query"
              class="block appearance-none w-full border border-white bg-white text-xs text-grey-darker py-1 px-2 rounded-l focus:outline-none focus:bg-white focus:border-grey" />



            <button @click.prevent="doSearch" href="#" class="text-xs no-underline border p-1 border-full-blue rounded-r text-full-blue">Search</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
 export default {
   props: {
     showNav: {
       type: Boolean,
       default: true
     }
   },
   data () {
     return {
       query: this.$route.params.query || ''
     }
   },
   methods: {
     doSearch () {
       this.$router.push({name: 'search', params: {query: this.query}})
     },
   }
 }
</script>

<style scoped>
 .logo {
   display: flex;
   align-items: center;
   flex: 1;
   justify-content: space-between;
   font-size: 26px;
   min-width: 25px;
 }
</style>
